<template>
    <div class="simple-table-page">
        <div class="simple-table-page-top">
            <div v-if="pageTitle" class="simple-table-page-title">
                {{ pageTitle }}
                <slot name="describe" />
            </div>
            <slot name="top" />
        </div>
        <div class="simple-table-page-content">
            <div class="simple-table-page-operation">
                <div class="simple-table-page-operation-btns" v-show="operationBtns.length || $slots['operation']">
                    <el-button v-for="(btn, idx) in operationBtns" :key="idx" v-bind="btn" @click="btn.onClick">
                        {{ btn.text }}
                    </el-button>
                    <slot name="operation" />
                </div>
                <div class="simple-table-page-filter">
                    <FormRender
                        :comps="filters"
                        :formData="filterFormValues"
                        :verifyInfo="{}"
                        :validation="{}"
                        :inline="true"
                        @change="filterChange"
                    />
                </div>
            </div>
            <slot name="beforeTable" />
            <Table
                :cur-page="curPage"
                :config="tableConfig"
                :dataset="dataset"
                :total="total"
                :showCheckedNum="true"
                @pageChange="pageChange"
                @columnClick="columnClick"
                @selectionChange="selectionChange"
                @bottomClick="bottomClick"
            />
            <slot name="bottom" />
        </div>
    </div>
</template>

<script>
import Table from "@/views/zhiji/bComponents/newTable/Table.vue";
import FormRender from "@/views/zhiji/components/commonForm/FormRender.vue";

export default {
    name: "SimpleTablePage",
    components: {
        Table,
        FormRender
    },
    props: {
        columns: {
            type: Array,
            default: () => []
        },
        filters: {
            type: Array,
            default: () => []
        },
        filterInit: {
            type: Object,
            default: () => ({})
        },
        operationBtns: {
            type: Array,
            default: () => []
        },
        footerOperationBtns: {
            type: Array,
            default: () => []
        },
        pageLength: {
            type: Number,
            default: 10
        },
        pageLengthRank: {
            type: Array,
            default: () => [10, 20, 30]
        },
        total: {
            type: Number,
            default: 0
        },
        dataset: {
            type: Array,
            default: () => []
        },
        pageTitle: {
            type: String,
            default: ""
        },
        isHideFooter: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            filterFormValues: this.filterInit || {},
            curPage: 1,
        };
    },
    computed: {
        tableConfig() {
            return {
                columns: this.columns,
                pageLength: this.pageLength,
                pageLengthRank: this.pageLengthRank,
                bottomButtons: this.footerOperationBtns,
                isHideFooter: this.isHideFooter
            };
        }
    },
    methods: {
        filterChange(data) {
            this.filterFormValues = data;
            this.$emit("filterChange", data);
        },
        pageChange(page) {
            const { curPage } = page;
            this.curPage = curPage;
            this.$emit("pageChange", page);
        },
        columnClick(event) {
            this.$emit("columnClick", event);
        },
        selectionChange(rows) {
            this.$emit("selectionChange", rows);
        },
        bottomClick(rows) {
            this.$emit("bottomClick", rows);
        }
    }
};
</script>

<style scoped>
.simple-table-page {
    /* padding: 16px; */
    width: 100%;
    height: 100%;
    background: #f2f7fb;
    box-sizing: border-box;
    overflow-y: auto;
}
.simple-table-page-title {
    font-size: 16px;
    font-weight: bold;
    padding: 20px 32px;
    display: flex;
    align-items: center;
    width: 100%;
    background: #fbfcfd;
    border-bottom: 1px solid #e3ecf5;
    box-sizing: border-box;
}
.simple-table-page-content {
    background: #ffffff;
    border: 1px solid #e3ecf5;
    margin: 16px 16px 0 16px;
    padding: 20px 24px 0 24px;
}
.simple-table-page-operation {
    margin-bottom: 20px;
    display: flex;
}
.simple-table-page-operation-btns {
    flex-shrink: 0;
    flex-grow: 0;
    margin-right: 20px;
}
.simple-table-page-filter {
    flex: 1;
    display: flex;
    justify-content: flex-end;
}
.question-search {
    margin-left: 50px;
}
</style>
